import { List } from 'immutable'

/* eslint-disable import/prefer-default-export */
export function selectAccountOwnerProfile (state) {
  const { userProfiles } = state
  const profiles = userProfiles.get('data', List())

  return profiles.find((p = List()) => p.get('uid') === p.get('account_owner_uid'))
}
